'use strict';

var _ = require('lodash');
var ChartDashboardSchedule = function ChartDashboardSchedule(AbstractChart, scalesService, chartGroups, chartSimpleBars, chartXAxis, chartYAxis, chartConstants) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters) {
    AbstractChart.call(this, container);

    // chart components
    var groups = chartGroups('label', formatters && formatters.tooltipFormatter, true);
    var bars = chartSimpleBars('data');
    var xAxisTickValuesHandler = function xAxisTickValuesHandler(data) {
      return _.map(data, 'label');
    };
    var xAxis = chartXAxis(formatters.xAxisTickFormatter, xAxisTickValuesHandler);
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT).withHorizontalLinesValues([0]);
    yAxisLeft.label('% Change YOY');
    this.render = function (data) {
      this.initChart(data, undefined, chartParams);
      this.scales = chartScales(this.params, this.data);
      this.callForDataGroup([yAxisLeft, groups, bars, xAxis], this.scales);
    };
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ChartDashboardSchedule.$inject = ['AbstractChart', 'ScalesService', 'ChartElementsGroup', 'ChartElementsSimpleBars', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsConstants'];
module.exports = ChartDashboardSchedule;